<template>
     <v-row>
    <v-col>
  <v-container fluid>
    <v-row v-if="loader">
      <v-col class="d-flex flex-row align-center justify-space-around">
        <v-progress-circular indeterminate color="success"/>
      </v-col>
    </v-row>
    <v-row v-if="!loader">
      <v-col>
        <span>
          <span class="d-flex flex-row align-center flex-wrap hideOnPagePrint" style="gap: 8px;">
            <v-btn text @click="$router.go(-1)"><v-icon>mdi-arrow-left</v-icon></v-btn>
            <h1 style="white-space: nowrap;">Viewing Register</h1>
            <dynamicButtonContainer v-if="register && Object.keys(register).length>0" class="ml-2 registerViewPrintButtons" :containerId="`${getGlobalValue('VEC_PRINT_SYSTEM_CONTAINER_REGISTER_VIEW')}`" :data="{id1: register.uuid}"/>
            <v-btn class="ml-2" small color="success" v-if="register && Object.keys(register).length>0 && !register.closedAt && isAllowed('register', 'canCloseAny')" @click="$router.push(`/registers/close/${register.uuid}`)">Close Register</v-btn>
          </span>
          <h2 v-if="register && Object.keys(register).length>0">Register: {{register.uuid}}</h2>
          <span>
            <span class="d-flex flex-column">
              <span>Opening Time: {{utils.formatDate(register.openedAt, 'withTime')}} by {{lookupUsername(register.openedBy)}}</span>
              <span>Opening Notes:
                <pre class="pl-5">{{register.openingNotes}}</pre>
              </span>
              <br v-if="register.closedAt">
              <span v-if="register.closedAt">Closing Time: {{utils.formatDate(register.closedAt, 'withTime')}} by {{lookupUsername(register.closedBy)}}</span>
              <span v-if="register.closedAt">Closing Notes:
                <pre class="pl-5">{{register.closingNotes}}</pre>
              </span>
            </span>
          </span>
        </span>
      </v-col>
    </v-row>
    <v-row v-if="!loader">
      <v-col>
        <h2>Summary</h2>
        <div style="width: 100%; overflow-x: auto; overflow-y: hidden;">
        <table class="text-center" style="width: 100%; min-width: 600px;">
          <thead style="font-size: 18px;">
            <tr>
              <th class="text-left">Type</th>
              <th class="text-right">Expected</th>
              <th class="" style="">Counted</th>
              <th class="text-right">Differences</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(pt, i) of data.payments">
              <tr class="level1Row" v-if="pt.paymentTypeId!=getGlobalValue('cashPayment')" :key="i">
                <td style="font-size: 16px;" class="text-left">{{pt.PaymentType.name}}</td>
                <td class="text-right">{{utils.formatCurrency(pt.metadata.expected)}}</td>
                <td class="px-5">{{utils.formatCurrency(pt.amount)}}</td>
                <td class="text-right">{{utils.formatCurrency(pt.metadata.expected-pt.amount)}}</td>
              </tr>
              <template v-else>
                <tr class="level1Row cashRow" style="font-weight: bold;" :key="i">
                  <td style="font-size: 16px;" class="text-left">{{pt.PaymentType.name}}</td>
                  <td class="text-right">{{utils.formatCurrency(pt.metadata.expected)}}</td>
                  <td class="px-5">
                    <span>{{utils.formatCurrency(pt.amount)}}</span>
                  </td>
                  <td class="text-right">{{utils.formatCurrency(pt.metadata.expected-pt.amount)}}</td>
                </tr>
                <tr class="level1Row cashRow" :key="i+'breakdown'" v-if="pt.metadata.showBreakdown">
                  <td>Breakdown</td>
                  <td colspan="2">
                    <span class="d-flex flex-column">
                      <span class="text-left pl-8" v-for="denom of pt.metadata.denominations" :key="denom.key">
                        <span>{{pt.metadata.amountBreakdown[denom.key]}}</span>
                        <span style="width: 100px;" class="pl-1 text-left">x {{denom.label}}</span>
                      </span>
                    </span>
                  </td>
                  <td></td>
                </tr>
                <tr class="pl-5 level1Row cashRow" :key="i+'2nd'">
                  <td>
                    <span class="d-flex flex-row justify-space-between">
                      <span class="pl-5 text-left cashMoveFirstPrint">Cash Movements</span>
                      <span class="text-center cashMoveSecondPrint"><b>User</b></span>
                      <span style="width: 33%;" class="text-left"><b>Time</b></span>
                    </span>
                  </td>
                  <td class="text-right"><b>Amount</b></td>
                  <td colspan="2" class="text-right"><b>Reason</b></td>
                </tr>
                <template v-for="(trans, ti) in cashMovementTransactions">
                  <tr class="level2Row cashRow" :key="i+'2nd'+ti">
                    <td>
                    <span class="d-flex flex-row justify-space-between">
                      <span class="text-right cashMoveFirstPrint"></span>
                      <span class="text-center cashMoveSecondPrint">{{lookupUsername(trans.receivedBy)}}</span>
                      <span style="width: 33%;" class="text-left">{{`${utils.formatDate(trans.createdAt)} ${utils.formatTime(trans.createdAt)}`}}</span>
                    </span>
                    </td>
                    <td :class="`${trans.transactionType===5?'red--text':''} ${trans.metadata?.type==='Opening Float'?'blue&#45;&#45;text':''} text-right pr-1`">{{utils.formatCurrency(trans.amount)}}</td>
                    <td colspan="2" class="text-right pr-1">{{trans.metadata?.type==='Opening Float'?'Opening Float':(trans.notes||'None')}}</td>
                  </tr>
                </template>
                <tr class="level1Row cashRow" :key="i+'3rd'">
                  <td class="pl-5 text-left">Cash Payments From Orders</td>
                  <td class="text-right">{{utils.formatCurrency(pt.metadata.cashReceived)}}</td>
                  <td/>
                  <td/>
                </tr>
                <tr class="level1Row cashRow" :key="i+'4th'">
                  <td class="pl-5 text-left">Cash Redeemed</td>
                  <td class="text-right">{{utils.formatCurrency(pt.metadata.cashRedeemed)}}</td>
                  <td/>
                  <td/>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="register.Transactions && register.Transactions.length>0">
      <v-col>
        <h2>All Transactions</h2>
        <div style="width: 100%; overflow-x: auto; overflow-y: hidden;">
        <table style="width: 100%; min-width: 700px;">
          <thead>
          <tr>
            <th class="text-left">Doc</th>
            <th class="text-left">Date</th>
            <th class="text-left">User</th>
            <th class="text-left">Type</th>
            <th v-if="showFlags" class="text-left">Flags</th>
            <th class="text-right">Amt</th>
            <th class="text-right">P.I.T. Total</th>
          </tr>
          </thead>
          <tbody>
          <tr :class="trans.voidedAt?'strikeout':''" v-for="(trans, k) of register.Transactions" :key="k" @click="(trans.orderId?$router.push(`/orders/view/${trans.orderId}`):null)" @mousedown.middle.prevent="utils.openInNewTab($router, (trans.orderId?$router.push(`/orders/view/${trans.orderId}`):null))">
            <td :style="`font-size: ${getGlobalValue('reportFontSize')?getGlobalValue('reportFontSize'):'16px'};`">
              <span v-if="trans.orderId && trans.transactionType===2">INV #{{trans.orderId}}</span>
              <span v-else-if="trans.transactionType===3">CN {{trans.CreditNotes.length>0?`#${trans.CreditNotes[0].id}`:''}}</span>
              <span v-else-if="trans.metadata.type">{{trans.metadata.type}}</span>
              <span v-else-if="trans.transactionType===4">Cash In</span>
              <span v-else-if="trans.transactionType===5">Cash Out</span>
            </td>
            <td :style="`font-size: ${getGlobalValue('reportFontSize')?getGlobalValue('reportFontSize'):'16px'};`">{{utils.formatDate(trans.createdAt)}} {{utils.formatTime(trans.createdAt)}}</td>
            <td :style="`font-size: ${getGlobalValue('reportFontSize')?getGlobalValue('reportFontSize'):'16px'};`">{{lookupUsername(trans.receivedBy)}}</td>
            <td :style="`font-size: ${getGlobalValue('reportFontSize')?getGlobalValue('reportFontSize'):'16px'};`">
              <span v-if="trans.transactionType===2 || trans.transactionType===4 || trans.transactionType===5">{{paymentTypes.find(x => x.id===trans.paymentType)?paymentTypes.find(x => x.id===trans.paymentType).name:'ERROR'}}</span>
              <span v-if="trans.transactionType===3">Redeemed CN as {{paymentTypes.find(x => x.id===trans.paymentType)?paymentTypes.find(x => x.id===trans.paymentType).name:'ERROR'}}</span>
            </td>
            <td v-if="showFlags" :style="`font-size: ${getGlobalValue('reportFontSize')?getGlobalValue('reportFontSize'):'16px'};`">{{trans.flags}}</td>
            <td :style="`font-size: ${getGlobalValue('reportFontSize')?getGlobalValue('reportFontSize'):'16px'};`" class="text-right">{{utils.formatCurrency(trans.amount)}}</td>
            <td :style="`font-size: ${getGlobalValue('reportFontSize')?getGlobalValue('reportFontSize'):'16px'};`" class="text-right">{{utils.formatCurrency(trans.pitTotal)}}</td>
          </tr>
          </tbody>
        </table>
        </div>
      </v-col>
    </v-row>
  </v-container>
    </v-col>
   </v-row>
</template>
<style>
table{
  border-collapse: collapse;
}
.level1Row{
  border-top: 1px solid #ddd;
}
.level1Row>td{
  padding: 5px 0 5px 0;
  vertical-align: top;
}
.level2Row{
  border-top: 1px solid #ddd;
}
.cashRow {
  background: white;
}
.level2Row .cashRow td{
  padding: 0px;
}
table th, .level1Row>td{
  padding-left: 5px;
  padding-right: 5px;
}
.cashMoveFirstPrint{
  width: 33%;
}
.cashMoveSecondPrint{
  width: 33%;
}
@media print {
  .cashMoveFirstPrint{
    width: 10%;
  }
  .cashMoveSecondPrint{
    width: 56%;
  }
}
/* dynamicButtonContainer's root forces width:100%, which as a flex item claims the whole
   row and pushes the header to wrap even when there's plenty of room alongside the title */
.registerViewPrintButtons{
  width: auto !important;
}
</style>
<script>
import { mapGetters } from 'vuex'
import axios from "axios";
import utils from "../../plugins/helpers"
import dynamicButtonContainer from '../../components/dynamicButtonContainer.vue';

export default {
  name: 'Home',
  components: {
    dynamicButtonContainer
  },
  data () {
    return {
      utils: utils,

      loader: false,

      data: {
        closingFloat: 0,
        closingNotes: '',
        payments: []
      },

      register: {},
      cashMovementTransactions: [],

      showBreakdown: true,

      closeRegisterDialog: {
        isOpen: false,
        isLoading: false
      }
    }
  },
  computed: {
    ...mapGetters(['getEndpoint', 'getBranch', 'getCurrentRegister', 'lookupUsername', 'getGlobalValue', 'paymentTypes', 'isAllowed']),
    showFlags(){
      return this.getGlobalValue('VEC_SHOW_ORDER_FLAGS_COLUMN') !== 'false';
    }
  },
  async mounted(){
    try {
      this.loader = true;

      let res = await axios.get(`${this.getEndpoint}/api/registers/sessionWithTransactions/${this.$route.params.id}`)
      this.register = res.data.data

      this.cashMovementTransactions = this.register?.Transactions?.filter(x => x.transactionType===4 || x.transactionType===5)
      this.data.payments = this.register.formattedOutput||[];
    } finally {
      this.loader = false;
    }
  },
  methods: {
    computeBreakdownTotal(){
      let total = 0;

      let found = this.data.payments.find(x => x.paymentTypeId==this.getGlobalValue('cashPayment'));
      if(found){
        for(let denom of found.metadata.denominations||[]){
          total += parseInt(found.metadata.amountBreakdown[denom.key]||0)*denom.value;
        }
      }

      found.amount = utils.pff2(total);
    },
    toggleBreakdownView(){
      // let found = this.data.payments.find(x => x.paymentTypeId==this.getGlobalValue('cashPayment'));
      // if(!found) return;
      // for(let key in Object.keys(found.metadata.amountBreakdown)){
      //   found.metadata.amountBreakdown[key] = 0;
      // }
      // found.amount = 0;
      this.showBreakdown = !this.showBreakdown;
    },
  }
}
</script>
